import { defineStore } from 'pinia';
import { RetrieveService as _retrieve } from '@/services/store/retrieve.service';
import { ref } from 'vue';

export const useRetrieveStore = defineStore('Retrieve', () => {
  // ------------------------------------------------------------- //
  // Define State
  // ------------------------------------------------------------- //
  const retrieveExpiredQuoteUrl = ref<string>();

  const retrieveQuote = (quoteNumber: string, postcode: string) => {
    return _retrieve.retrieveQuote(quoteNumber?.trim(), postcode?.trim());
  };

  return {
    retrieveQuote,
    retrieveExpiredQuoteUrl,
  };
});
